/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![TextUserIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABgUlEQVR4nM1VPU8CQRBdK1tbEjv1N2hpgpoz3M7MamSGUPgPUAr9L2hl7PwZ8qHW2mvUwpgQtbbALBwEjlvYAy7xJdvs2503M3k7q9QCAEYKQPKukd9C4n21aGjkNyDp2KVJXtNniHKnSZqZCBhTznUvorRdZ2xbrIgNro0E6bKH4k43O+R6Eh8EwTKAgEY5B+IzxJK2e/4CxCdR+bU4p01xC5Bf+u0ZatMzgGx6CWjki6hFpyP7+mgdiH/iwQciKN9EvDa9ApSGvRAS743u87Ur+FAlV6PZkjQnX+AvxOOVSPhTk9xOOHsPxB+xbLk+JavfwkFpIxJ4DLF06DxrimUgfprYnhA533OQNFQWACMVl4MQeRtQbrSR3dkFSGq9cqXiclcS5y+AkYOQ82m4RExzEPgux4v3cVDHZ1nrpp1BrThnH93c7urPIE18OS4uVZe7vDFwCUg1IwdxK2kGzeSgJNhpaIMYU15N4NoRl5tDgB/sV6mUWhrjrKWzGh//Dn+wR12B6v4h+gAAAABJRU5ErkJggg==)
 */
export const TextUserIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M21 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM14 9.27a4.77 4.77 0 0 1 4.77-4.77h.46A4.77 4.77 0 0 1 24 9.27c0 .4-.33.73-.73.73h-.11a.26.26 0 0 1-.26-.2 5.17 5.17 0 0 0-.66-1.46c-.06-.1-.21-.04-.2.08l.13 1.3c.02.15-.1.28-.25.28h-5.84a.25.25 0 0 1-.25-.27l.13-1.3c.01-.13-.14-.2-.2-.09-.24.37-.52.9-.66 1.46a.26.26 0 0 1-.26.2h-.1a.73.73 0 0 1-.74-.73Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M10.18 8h1.33c.27 0 .5.22.54.49.03.21.09.43.16.63.15.39-.1.88-.52.88H9.85l-.67 4h4.97l.37-2.23c.05-.29.33-.47.62-.45l.26.02h.63c.31 0 .55.27.5.58L16.18 14H20a1 1 0 1 1 0 2h-4.15l-.86 5.16a1 1 0 0 1-1.98-.32l.8-4.84H8.86l-.86 5.16A1 1 0 0 1 6 20.84L6.82 16H3a1 1 0 1 1 0-2h4.15l.67-4H4a1 1 0 0 1 0-2h4.15l.86-5.16a1 1 0 1 1 1.98.32L10.19 8Z"
        className={colorClass}
      />
    </svg>
  );
};
